module.exports = __webpack_public_path__ + "static/media/areas02.38bd8706.jpg";